import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon } from 'lucide-react';
import { twMerge } from 'tailwind-merge';
import { ButtonLink } from '../ui/ButtonLink';
import { plans } from '../../data/landing';
import { rise, spring, stagger } from '../../utils/motion';
export function PricingPlans() {
  return <div data-id="element-402" data-mp="ow8m1ov1jdts">
      <motion.ul variants={stagger} initial="hidden" whileInView="show" viewport={{
      once: true,
      margin: '-10% 0px'
    }} className="grid gap-4 md:grid-cols-3" data-id="element-403" data-mp="ovh3bemjlakx">
        {plans.map(p => <motion.li key={p.id} variants={rise} className="flex" data-id="element-404" data-mp="yp7q8f30tcyi">
            <motion.div whileHover={{
          y: -6
        }} transition={spring.bouncy} className={twMerge('flex w-full flex-col rounded-lg p-7', p.highlight ? 'bg-ink text-bg' : 'border border-line bg-surface')} data-id="element-405" data-mp="1cm3029r3j8fm">
              <p className={twMerge('text-sm font-bold', p.highlight ? 'text-accent' : 'text-brand-strong')} data-id="element-406" data-mp="3ae78vnajx6cy">{p.audience}</p>
              <p className="mt-1 text-2xl font-bold" data-id="element-407" data-mp="2kf7tjfwy3mf2">{p.name}</p>
              <p className="mt-5 flex items-baseline gap-2" data-id="element-408" data-mp="2pgookusr0enq">
                <span className="tabular text-[48px] font-bold leading-none tracking-[-0.02em]" data-id="element-409" data-mp="2ueqbxrx7j050">{p.price}</span>
                <span className={twMerge('text-[15px]', p.highlight ? 'opacity-70' : 'text-ink-3')} data-id="element-410" data-mp="2z706jl99oodm">{p.cadence}</span>
              </p>
              <ul className="mt-7 space-y-3" data-id="element-411" data-mp="344rzmilnegje">
                {p.features.map(f => <li key={f} className="flex gap-3 text-[15px] leading-snug" data-id="element-412" data-mp="38525lv9fx6y9">
                    <CheckIcon className={twMerge('mt-0.5 h-4 w-4 shrink-0', p.highlight ? 'text-accent' : 'text-brand-strong')} strokeWidth={3} data-id="element-413" data-mp="3d6rd50xgf2hl" />
                    {f}
                  </li>)}
              </ul>
              <div className="mt-auto pt-8" data-id="element-414" data-mp="1itjj3bhayux0">
                <ButtonLink to={p.to} variant={p.highlight ? 'accent' : 'primary'} className="w-full" data-id="element-415" data-mp="1nq9w1pxt9ae7">
                  {p.cta}
                </ButtonLink>
              </div>
            </motion.div>
          </motion.li>)}
      </motion.ul>
      <p className="mt-6 max-w-[70ch] text-[15px] leading-relaxed text-ink-2" data-id="element-416" data-mp="1bqbiwdqa0ont">
        Plus a <span className="font-bold text-ink" data-id="element-417" data-mp="1ppupv37cptyj">6% booking fee</span> (min ฿150), paid by the organiser only when a gig is confirmed. Performers always receive their full quoted fee.
      </p>
    </div>;
}